module.exports = __webpack_public_path__ + "img/icon-noti.0619c044.svg";